import { Icon } from '@iconify/react'
import './CoursesPage.css'

const CoursesPage = () => {
  return (
    <div className="courses-page">
      <div className="courses-placeholder">
        <Icon icon="solar:notebook-minimalistic-linear" width={48} height={48} className="courses-placeholder-icon" />
        <h2 className="courses-placeholder-title">Скоро..</h2>
        <p className="courses-placeholder-text">
          Данный раздел находится в разработке, следите за анонсами в Secret Chat
        </p>
      </div>
    </div>
  )
}

export default CoursesPage
